<div class="flex flex-col min-h-screen">
    <!-- Header Desktop -->
    <div class="hidden md:block">
        <pax-header [showNavigation]="!isAuthRoute" [navigationItems]="navigationItems()"></pax-header>
    </div>

    <!-- Main Content -->
    <main class="flex-grow bg-background">
        <router-outlet />
    </main>

    <!-- Footer Desktop - Only visible on screens >= 768px (md breakpoint) -->
    <div>
        <!-- <pax-footer
      [lang]="lang()"
      [availableLanguages]="availableLanguages"
      [footerItems]="footerItems"
      (languageChange)="onLanguageChange($event)"
    ></pax-footer> -->
    </div>

    <!-- Scroll to top - Hidden on mobile -->
    <div class="hidden md:block">
        <pax-scroll-to-top />
    </div>
</div>

<!-- Replace the p-toast with our custom toast -->
<pax-toast-container />
